import * as React from "react";
import { Route, Routes } from "react-router-dom";

export const CandyGlimmer = (props: { text: string }) => {
  const gaussian = () => {
    let u = 0;
    let v = 0;
    let r = 0;
    while (r <= 0 || r >= 1) {
      u = 2 * Math.random() - 1;
      v = 2 * Math.random() - 1;
      r = u * u + v * v;
    }
    return u * Math.sqrt((-2 * Math.log(r)) / r);
  };

  const ref = React.useRef<HTMLDivElement | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [seed, setSeed] = React.useState(0);

  const roll = React.useCallback(() => {
    setTimeout(
      () =>
        setSeed((start) => {
          let off = 0;
          for (let i = 1; ; i++) {
            let wait = 0;
            while (wait < 20 || wait > 1000) {
              wait = Math.round(Math.max(20, Math.pow(off / 50, 1.5)) * Math.exp(gaussian()));
            }
            off += wait;
            setTimeout(() => setSeed((prev) => (prev === start + i ? prev + 1 : prev)), off);
            if (off >= 2500) {
              break;
            }
          }
          return start + 1;
        }),
      0,
    );
  }, []);

  React.useEffect(() => {
    setTimeout(() => roll(), 0);
  }, [roll]);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    el.addEventListener("pointerenter", roll);
    return () => el.removeEventListener("pointerenter", roll);
  }, [ref, roll]);

  return (
    <div ref={ref} className="p-4 -m-4 w-fit select-none font-mono font-medium text-[11px] md:text-[12px] tracking-tighter">
      {props.text.split("").map((chr, idx) => (
        <span
          key={idx}
          style={{
            color: ["#dc2626", "#c2410c", "#166534", "#1d4ed8", "#7c3aed"].at(Math.floor(Math.random() * 5)),
            filter: [
              `grayscale(${0.7 + 0.1 * (1 - Math.pow(Math.random(), 1.5))})`,
              `hue-rotate(${30 * gaussian()}deg)`,
              `brightness(${1 + 0.05 * gaussian()})`,
              `opacity(${0.6 + 0.2 * Math.pow(Math.random(), 2)})`,
            ].join(" "),
          }}
        >
          {chr}
        </span>
      ))}
    </div>
  );
};
